{
  "version": 1,
  "asset_id": "7eec5ecd-8892-4437-afdb-a7af86795d54",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/7eec5ecd-8892-4437-afdb-a7af86795d54/ai-search-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/7eec5ecd-8892-4437-afdb-a7af86795d54/ai-search-640.webp",
  "original_filename": "ai-search-640.webp",
  "size": 19224,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:45Z"
}
